const MOIS = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

export function formatSiren(s) {
  if (!s) return "";
  const d = String(s).replace(/\D/g, "");
  if (d.length !== 9) return s;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 9)}`;
}

export function formatSiret(s) {
  if (!s) return "";
  const d = String(s).replace(/\D/g, "");
  if (d.length !== 14) return s;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6, 9)} ${d.slice(9)}`;
}

export function formatCapital(montant, devise = "EUR") {
  if (montant === null || montant === undefined) return "";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: devise, maximumFractionDigits: 2 }).format(montant);
}

export function formatDate(iso) {
  if (!iso) return null;
  const parts = String(iso).split("-");
  if (parts.length < 3) return iso;
  const [y, m, d] = parts;
  const mi = parseInt(m, 10) - 1;
  if (mi < 0 || mi > 11) return iso;
  return `${parseInt(d, 10)} ${MOIS[mi]} ${y}`;
}

export function formatDateTime(iso) {
  if (!iso) return null;
  try {
    const dt = new Date(iso);
    return dt.toLocaleDateString("fr-FR", {
      day: "numeric", month: "long", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

/* Jolie casse pour les noms en MAJUSCULES issus de la source */
export function titleCase(str) {
  if (!str) return str;
  return str
    .toLowerCase()
    .replace(/(^|[\s'’\-\/])([\p{L}])/gu, (m, sep, chr) => sep + chr.toUpperCase());
}

const PRINTER_BASE = "https://printer.fr/configurateur";

export function buildStampLines(c) {
  const lines = [];
  if (c?.nom) lines.push(c.nom);
  if (c?.adresse) lines.push(c.adresse);
  const cpVille = [c?.code_postal, c?.ville].filter(Boolean).join(" ").trim();
  if (cpVille) lines.push(cpVille);
  if (c?.telephone) lines.push(`Tél. ${c.telephone}`);
  if (c?.rcs) {
    lines.push(c.rcs);
  } else if (c?.siren) {
    const d = String(c.siren).replace(/\D/g, "");
    lines.push(`SIREN ${d.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3")}`);
  }
  if (c?.complement) lines.push(c.complement);
  return lines;
}

export function buildPrinterUrl(c) {
  const p = new URLSearchParams();
  p.set("utm_source", "infosociete");
  p.set("utm_medium", "fiche-entreprise");
  if (c?.nom) p.set("raison_sociale", c.nom);
  if (c?.siren) p.set("siren", String(c.siren).replace(/\D/g, ""));
  if (c?.siret) p.set("siret", String(c.siret).replace(/\D/g, ""));
  if (c?.adresse) p.set("adresse", c.adresse);
  if (c?.code_postal) p.set("code_postal", c.code_postal);
  if (c?.ville) p.set("ville", c.ville);
  if (c?.telephone) p.set("telephone", c.telephone);
  if (c?.complement) p.set("complement", c.complement);

  // Lignes structurées pour que le configurateur génère un tampon multi-lignes
  const lines = buildStampLines(c);
  p.set("nb_lignes", String(lines.length));
  p.set("lignes", lines.join("\n"));
  lines.forEach((l, i) => p.set(`ligne${i + 1}`, l));

  // Le configurateur printer.fr lit `ref` (identifiant du modèle) et `siret`
  const ref = c?.modele || "4914";
  p.set("ref", ref);
  p.set("format", ref);
  p.set("type", "printy");
  if (!p.get("siret") && c?.siren) p.set("siret", String(c.siren).replace(/\D/g, ""));
  return `${PRINTER_BASE}?${p.toString()}`;
}
